export type InboundFloorLeaveReason = "idle" | "session_lost" | "ended_remotely" | "stopped";

export type InboundFloorLeaveInput =
  | InboundFloorLeaveReason
  | {
      reason: InboundFloorLeaveReason;
      ownerDeparting?: boolean;
    };

/**
 * Arrivals / Receive / Holding / To stock share one labor tracker.
 * Idle clock-out and unexpected session loss return the operator to floor home (`/`).
 * Intentional clock-out also goes home without the failure tone.
 */
export function inboundFloorLeavePlan(input: InboundFloorLeaveInput): {
  playFailureSound: boolean;
  navigateHome: boolean;
} {
  const reason = typeof input === "string" ? input : input.reason;
  const ownerDeparting = typeof input === "object" && input.ownerDeparting === true;
  if (ownerDeparting) {
    return { playFailureSound: false, navigateHome: false };
  }
  if (reason === "stopped") {
    return { playFailureSound: false, navigateHome: true };
  }
  return { playFailureSound: true, navigateHome: true };
}
